export type SignupNames={firstName:string;lastName:string};
const pending=new Map<string,SignupNames>();
const key=(uid:string)=>'khojipark-signup:'+uid;
export function rememberSignupNames(uid:string,names:SignupNames){pending.set(uid,names);try{localStorage.setItem(key(uid),JSON.stringify(names));}catch{/* Keep the current signup recoverable in memory. */}}
export function pendingSignupNames(uid:string):SignupNames|null{
 if(pending.has(uid))return pending.get(uid)!;
 try{const value=JSON.parse(localStorage.getItem(key(uid))??'null');if(typeof value?.firstName==='string'&&typeof value.lastName==='string'&&value.firstName.trim()&&value.firstName.length<=100&&value.lastName.length<=100)return value;}catch{/* Invalid or unavailable cache. */}
 return null;
}
export function clearSignupNames(uid:string){pending.delete(uid);try{localStorage.removeItem(key(uid));}catch{/* Device storage is optional. */}}
